import {
  alertClasses,
  inputLabelClasses,
  Alert as MuiAlert,
  outlinedInputClasses,
  Stack,
  styled,
  TableContainer,
  TextField,
} from '@mui/material';

export const StyledAlert = styled(MuiAlert)(({ theme }) => ({
  borderColor: theme.palette.custom.OV.sys.outlineVariant,
  backgroundColor: theme.palette.custom.OV.sys.surface,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  [`.${alertClasses.icon}`]: {
    color: theme.palette.custom.OV.sys.secondary,
  },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: theme.spacing(1),
}));

export const StyledTextField = styled(TextField)(() => ({
  [`.${inputLabelClasses.root}.${inputLabelClasses.focused}`]: {
    display: 'none',
  },
  [`.${outlinedInputClasses.notchedOutline} > legend`]: {
    visibility: 'hidden',
    width: 0,
  },
}));

export const StyledRoundedBox = styled(Stack)(({ theme }) => ({
  borderColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));
